export const AssociateKycUserDesc = [
  {
    header: "Associate Kyc User",
    subHeader: "AAPI reference to Associate Kyc User",
    description: "To Associate kyc with token.",
    services: [
      {
        url: "api/hts/token/user/associatekyc",
        type: "post",
        desc: "To Associate kyc with token.",

        requestFieldDetails: {
          headerParam: [],
          bodyParam: [
            {
              fieldName: "adminOperatorId",
              dataType: "String",
              required: true,
              minLength: 3,
              maxLenth: 15,
              description: "The Id of the admin wallet",
            },
            {
              fieldName: "adminOperatorKey",
              dataType: "String",
              required: true,
              minLength: 3,
              maxLenth: 15,
              description:
                "The key is used to sign all transactions executed by this client, private keys are generated by an algorithm and are unique to one another.",
            },
            {
              fieldName: "operatorId",
              dataType: "String",
              required: true,
              minLength: 3,
              maxLenth: 15,
              description: "The Id of the user wallet",
            },
            {
              fieldName: "operatorKey",
              dataType: "String",
              required: true,
              minLength: 3,
              maxLenth: 15,
              description:
                "The operator key is used to sign all transactions executed by this client, private keys are generated by an algorithm and are unique to one another.",
            },
            {
              fieldName: "clientId",
              dataType: "String",
              required: true,
              minLength: 3,
              maxLenth: 15,
              description:
                "project user name which we provide to the other projects",
            },
            {
              fieldName: "tokenId",
              dataType: "String",
              required: true,
              minLength: 3,
              maxLenth: 15,
              description: "The ID of the token Id",
            },
          ],
        },
        responseFieldDetails: [
          {
            fieldName: "response",
            message: "Associate KYC user fetched successfully",
            value: "null",
            type: "String",
            description: "The minted token balance will appear here",
          },
        ],
      },
    ],
  },
];
